// The bell in the header: the user's notices (/Notifications/Recent), polled every 30 seconds so an
// offer the customer just opened shows up within a minute. Clicking a notice marks it read and opens it.
import type { Alpine } from "alpinejs";

interface NoticeItem { id: string; text: string; url?: string; when: string; read: boolean }
interface NoticeReply { unread: number; items: NoticeItem[] }

const PollMs = 30_000;

function token(): string {
  return document.querySelector<HTMLInputElement>('input[name="__RequestVerificationToken"]')?.value ?? "";
}

async function markRead(id: string | null): Promise<void> {
  const body = new URLSearchParams();
  body.set("__RequestVerificationToken", token());
  if (id) body.set("id", id);
  try {
    await fetch("/Notifications/Read", {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    });
  } catch { /* the next poll shows the true state */ }
}

export function registerNotifications(alpine: Alpine): void {
  alpine.data("noticeBell", () => ({
    open: false,
    unread: 0,
    items: [] as NoticeItem[],
    timer: 0,

    init() {
      void this.load();
      this.timer = window.setInterval(() => { if (!document.hidden) void this.load(); }, PollMs);
    },

    destroy() { window.clearInterval(this.timer); },

    async load() {
      try {
        const res = await fetch("/Notifications/Recent", { headers: { "X-Requested-With": "XMLHttpRequest" } });
        if (!res.ok) return;
        const r = (await res.json()) as NoticeReply;
        this.unread = r.unread;
        this.items = r.items;
      } catch { /* offline for a moment: keep what is shown */ }
    },

    async go(n: NoticeItem) {
      if (!n.read) { await markRead(n.id); n.read = true; this.unread = Math.max(0, this.unread - 1); }
      if (n.url) window.location.href = n.url;
    },

    async readAll() {
      await markRead(null);
      this.items.forEach((n) => { n.read = true; });
      this.unread = 0;
    },
  }));
}
